import client from "./client";

export const getNewsletterPage = () => client.post("/newsletterpage/getPage");
export const addNewsletterPage = (payload) =>
  client.post("/newsletterpage/addpage", payload);
export const updateNewsletterPage = (payload) =>
  client.post("/newsletterpage/updatePage", payload);
